import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { getWhatsAppLink } from '../../utils/whatsapp';
export function FinalCTA() {
  return <section className="bg-arena flex flex-col items-center justify-center text-center px-6 md:px-20 pt-[64px] md:pt-[80px] pb-[64px] md:pb-[80px]" data-id="element-81" data-mp="qae7000e64ds">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="flex flex-col items-center max-w-[680px]" data-id="element-82" data-mp="lcmfv87kmman">
        <h2 className="font-display text-[36px] md:text-[52px] font-bold text-carbon leading-[1.1] tracking-tightest mb-4 max-w-[640px]" data-id="element-83" data-mp="2jsb173nwak5">
          Tu próxima oportunidad puede estar llegando ahora.
        </h2>

        <p className="font-body text-[18px] md:text-[20px] text-carbon/55 max-w-[440px] mb-10" data-id="element-84" data-mp="3610svqye3aev">
          Construyamos el sistema que se encargue de ella.
        </p>

        <a href={getWhatsAppLink('Hola, equipo de Origen Studio. Cuéntenme cómo puedo automatizar mi empresa.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-verde text-arena font-display font-semibold text-[15px] md:text-[16px] px-[32px] py-[16px] rounded-[6px] hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta active:translate-y-0 transition-all duration-200" data-id="element-85" data-mp="33day290992n6">
          Hablar con ORIGEN <ArrowRight size={18} className="ml-2" data-id="element-86" data-mp="2pdjpwowf6gh3" />
        </a>

        <p className="font-body text-[13px] text-carbon/40 mt-5" data-id="element-87" data-mp="2ud4kkn4k42o0">
          Cuéntanos cómo funciona hoy tu proceso.
        </p>

        <div className="mt-16 flex flex-col items-center" data-id="element-88" data-mp="4n1357l0tz4o">
          <div className="w-[60px] h-px bg-carbon/15 mb-4" data-id="element-89" data-mp="9n6z2zybq7sk" />
          <span className="font-body text-[12px] text-carbon/30" data-id="element-90" data-mp="9lca9ajxlvj7">
            Origen Studio · Colombia · 2025
          </span>
        </div>
      </motion.div>
    </section>;
}